import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Guid } from 'guid-typescript';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { Equipment } from '../models/equipment';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable()
export class EquipmentService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  public add(equip): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.post<Equipment>(environment.apiUrl + 'equipment/post', equip).subscribe(data => {
        this.snotifyService.success("Successfully created equipment");
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }
  public update(equip): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.post<Equipment>(environment.apiUrl + 'equipment/post', equip).subscribe(data => {
        this.snotifyService.success("Successfully updated equipment");

        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public delete(id: string, user: string): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.delete<Equipment>(environment.apiUrl + 'equipment/delete?id=' + id + '&userId='+user).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public postMassUpload(fileData): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'equipment/massUpload', fileData).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject(error);
      });
    });
  }

  public getByLocation(location_Id: number): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      ////console.log(environment.apiUrl + 'equipment/getbylocation?location_Id=' + location_Id);
      this.http.get<Equipment>(environment.apiUrl + 'equipment/getbylocation?location_Id=' + location_Id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }


  public sendClientRequest(dto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'equipment/postClientRequest',dto).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public transferItems(dto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'equipment/transferItems',dto).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }
  
  public get(id: string): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.get<Equipment>(environment.apiUrl + 'equipment/GetById?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  

  public getDescriptions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/getDescriptions').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }


  public save(equipment: Equipment): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      if (equipment.id == undefined || equipment.id == null)
        equipment.id = Guid.create().toString();
      this.http.post<Equipment>(environment.apiUrl + 'equipment/post', equipment).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully added equipment');
      }, error => {
        ////console.log(error);
        reject();
      });


    });
  }

 

  public uploadFile(dto): Promise<any> {
 
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiUrl + 'equipment/uploadFile', dto).subscribe(data => {
        this.snotifyService.success('Successfully uploaded file');
        resolve(data);
      }, error => {
        reject(error.error);
      });
    });
  }

  public removeFile(id: string, file_Name: string) {
    return this.http.delete(environment.apiUrl + 'equipment/removeFile?equipment_Id=' + id + "&file_Name=" + file_Name);
  }

  public getFiles(page: Page, id: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();
    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'File_Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&equipment_id=' + id;

      this.http.get<ServerData>(environment.apiUrl + 'equipment/getuploadedfiles?size=' + page.size + '&pageNumber=' + page.pageNumber + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;

        ////console.log(pagedData);

        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getROTEExcel(filters): Promise<any> {
    let params = '?company_Id=' + filters.company_Id;
    params += '&location_Id=' + filters.locationId;
    params += '&category_Id=' + filters.category_Id;
    params += '&serial=' + filters.serial_Num;
    params += '&asset=' + filters.asset_Num;

    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/getROTEExcel' + params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getROTEPDF(filters): Promise<any> {
    let params = '?company_Id=' + filters.company_Id;
    params += '&location_Id=' + filters.locationId;
    params += '&category_Id=' + filters.category_Id;
    params += '&serial=' + filters.serial_Num;
    params += '&asset=' + filters.asset_Num;

    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/getROTEPDF' + params).subscribe(data => {
      let blob = this.convertBase64toBlob(data, 'application/pdf');
        resolve(blob);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getRegisterExcel(filters): Promise<any> {
    let params = '?company_Id=' + filters.company_Id;
      params += '&location_Id=' + filters.location_Id;
      params += '&category_Id=' + filters.category_Id;
      params += '&serial=' + filters.serial_Num;
      params += '&asset=' + filters.asset_Num;
      params += '&description=' + filters.description;
      params += '&inspection_Status=' + filters.inspection_Status;
      params += '&showArchived=' + filters.showArchived;
      params += '&doc=' + filters.doc;

      if (filters.start_Date != null) params += '&start_Date=' + moment(filters.start_Date).format('YYYY-MM-DD');
      if (filters.end_Date != null) params += '&end_Date=' + moment(filters.end_Date).format('YYYY-MM-DD');

    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/GetRegisterExcel' + params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getRegisterPDF(filters): Promise<any> {
    let params = '?company_Id=' + filters.company_Id;
      params += '&location_Id=' + filters.location_Id;
      params += '&category_Id=' + filters.category_Id;
      params += '&serial=' + filters.serial_Num;
      params += '&asset=' + filters.asset_Num;
      params += '&description=' + filters.description;
      params += '&inspection_Status=' + filters.inspection_Status;
      params += '&showArchived=' + filters.showArchived;
      params += '&doc=' + filters.doc;

      if (filters.start_Date != null) params += '&start_Date=' + moment(filters.start_Date).format('YYYY-MM-DD');
      if (filters.end_Date != null) params += '&end_Date=' + moment(filters.end_Date).format('YYYY-MM-DD');
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/getRegisterPDF' + params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/pdf');
        resolve(blob);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getResults(page: Page, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string, contract_No: string,
     description: string, inspection_Status: number = -1, showArchived: number = 0, doc: string ,start_Date: string, end_Date: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial=' + serial_Num;
      params += '&asset=' + asset_Num;
      params += '&description=' + description;
      params += '&inspection_Status=' + inspection_Status;
      params += '&showArchived=' + showArchived;
      params += '&doc=' + doc;

     if(start_Date != null) params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
     if(end_Date != null) params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');


      this.http.get<ServerData>(environment.apiUrl + 'equipment/gettable?size=' + page.size 
        + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
      console.log(data);
        if(data == null || data.totalElements == null){
         reject();
         return;
        }
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }
  public getAllResults(page: Page, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string, contract_No: string,
     description: string, inspection_Status: number = -1, showArchived: number = 0, doc: string ,start_Date: string, end_Date: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial=' + serial_Num;
      params += '&asset=' + asset_Num;
      params += '&description=' + description;
      params += '&inspection_Status=' + inspection_Status;
      params += '&showArchived=' + showArchived;
      params += '&doc=' + doc;

      if (start_Date != null) params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      if (end_Date != null) params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      
      this.http.get<ServerData>(environment.apiUrl + 'equipment/gettable?size=' + 999999 + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        // page.totalElements = data.totalElements;
        // page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  
  public getEquipmentFiles(page: Page, id: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&Equipment_Id=' + id;
      this.http.get<ServerData>(environment.apiUrl + 'equipment/GetUploadedFiles?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getResultsForInspection(page: Page, company_Id: number, serial_Num: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&serial=' + serial_Num;

      this.http.get<ServerData>(environment.apiUrl + 'equipment/getinspectiontable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        //console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }
  public getAllResultsForInspection(page: Page, company_Id: number, serial_Num: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      page.pageNumber =0;
      page.size = 99999;

      let params = '&company_Id=' + company_Id;
      params += '&serial=' + serial_Num;

      this.http.get<ServerData>(environment.apiUrl + 'equipment/getinspectiontable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        //console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getAssetRegisterResults(page: Page, company_Id: number, location_Id: number, category_Id: number,
    serial_Num: string, asset_Num: string, contract_No: string, status: string, job_No: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;
      params += '&contract_Number=' + contract_No;
      params += '&status=' + status;
      params += '&job_No=' + job_No;

      this.http.get<ServerData>(environment.apiUrl + 'inspection/getAssetRegisterTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }



  public getExcel(page: Page, insurer_Id: number, broker_Id: number, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, 
    asset_Num: string, showArchived: number = 0): Promise<any> {

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;
      params += '&showArchived=' + showArchived;

      this.http.get<any>(environment.apiUrl + 'equipment/getexcel?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);

      }, error => {
        reject();
      });
    });
  }

 convertBase64toBlob(content, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;
        let byteCharacters = window.atob(content); //method which converts base64 to binary
        let byteArrays = [
        ];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, {
            type: contentType
        }); //statement which creates the blob
        return blob;
    }
}
